import { gql } from "graphql-request";

export const ADMIN_CHANGELOG_CATEGORIES = gql`
  query AdminChangelogCategories {
    adminChangelogCategories {
      _id
      name {
        ko
        en
      }
      color
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_CHANGELOG_ENTRIES = gql`
  query AdminChangelogEntries($input: AdminChangelogEntriesInputDto!) {
    adminChangelogEntries(input: $input) {
      items {
        _id
        title {
          ko
          en
        }
        categories {
          _id
          name {
            ko
            en
          }
          color
        }
        status
        publishedAt
        createdAt
        updatedAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_CHANGELOG_ENTRY_BY_ID = gql`
  query AdminChangelogEntryById($entryId: String!) {
    adminChangelogEntryById(entryId: $entryId) {
      _id
      title {
        ko
        en
      }
      body {
        ko
        en
      }
      featuredImageUrl
      categories {
        _id
        name {
          ko
          en
        }
        color
        sortOrder
      }
      status
      publishedAt
      createdAt
      updatedAt
    }
  }
`;
